import React, { useEffect, useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { MdEditDocument, MdDelete,MdFileOpen } from 'react-icons/md';
import api from '../../Services/api';
import CustomSnackbar from "../../Component/CustomSnackBar";
import { FaLink, FaFilePdf ,FaFileDownload} from 'react-icons/fa';
import { GoDownload } from "react-icons/go";


const NotificationsSection = () => {
  const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });
  const [notification, setNotification] = useState('');
  const [link, setLink] = useState('');
  const [file, setFile] = useState(null);
  const [savedData, setSavedData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [originalNotification, setOriginalNotification] = useState('');
  const [originalLink, setOriginalLink] = useState('');
  const [fileError, setFileError] = useState('');


  const isUnchanged = notification === originalNotification && link === originalLink &&  (typeof file === 'string' || file === null);;

  const triggerSnackbar = (type, message) => {
    setSnack({ open: true, message, severity: type, autoHideDuration: 3000 });
  };

  const handleClose = () => setSnack({ ...snack, open: false });

    useEffect(() => {
    fetchUploadedNotifications();
    if (fileError) triggerSnackbar('error', fileError);
  }, [fileError]);

  const fetchUploadedNotifications = async () => {
    try {
      const response = await api.Updates.getAllUploadedNotifications();
      setSavedData(response.data.data || []);
    } catch (error) {
      triggerSnackbar('error', error.message);
    }
  };

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const normalizeUrl = (url) => {
    if (!url) return '';
    return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
  };

  const handleSave = async () => {
    if (!notification.trim()) {
      triggerSnackbar('error', 'Please enter a notification');
      return;
    }
    if (link && !isValidUrl(link)) {
      triggerSnackbar('error', 'Please enter a valid URL');
      return;
    }

    try {
      const refLink = normalizeUrl(link);

      if (isEditing && editId) {
        const formData = new FormData();
        formData.append('Update', notification);
        formData.append('RefLink', refLink);
        if (file && typeof file !== 'string') {
          if (file.size > 6 * 1024 * 1024) {
            triggerSnackbar('error', 'File size should be less than 6MB');
            setFileError('File size should be less than 6MB');
            return;
          }
          formData.append('file', file);
        }

        const response = await api.Updates.EditNotifications(editId, formData);
        if (response.status === 200) {
          triggerSnackbar('success', response.data.message);
        }
      } else {
        const formData = new FormData();
        formData.append('Update', notification);
        formData.append('RefLink', refLink);
        if (file) {
          if (file.size > 6 * 1024 * 1024) {
            triggerSnackbar('error', 'File size should be less than 6MB');
            setFileError('File size should be less than 6MB');
            return;
          }
          formData.append('file', file);
        }

        const response = await api.Updates.uploadNotification(formData);
        if (response.status === 201) {
          triggerSnackbar('success', response.data.message);
        } else {
          triggerSnackbar('error', response.data.message || 'Something went wrong');
        }
      }

      fetchUploadedNotifications();
      resetForm();
    } catch (error) {
      triggerSnackbar('error', error?.response?.data?.message || error.message);
    }
  };

  const resetForm = () => {
    setNotification('');
    setLink('');
    setFile(null);
    setIsEditing(false);
    setFileError('');
    setEditId(null);
    const input = document.getElementById('document');
    if (input) input.value = '';
  };

  const handleDelete = async (id) => {
    try {
      const response = await api.Updates.deleteNotifications(id);
      triggerSnackbar('success', response.data.message);
      fetchUploadedNotifications();
    } catch (error) {
      triggerSnackbar('error', error?.response?.data?.message || error.message);
    }
  };

  const handleFileDrop = (e, setFile, setFileError, triggerSnackbar) => {
  e.preventDefault();
  const droppedFile = e.dataTransfer.files[0];
  const input = document.getElementById('document');

  if (droppedFile && droppedFile.size > 6 * 1024 * 1024) {
    triggerSnackbar('error', 'File size should be less than 6MB');
    setFileError('File size should be less than 6MB');
    setFile(null);
    if (input) input.value = '';
  } else {
    setFile(droppedFile);
    setFileError('');
  }

  e.currentTarget.style.backgroundColor = '';
};

  return (
    <>
      <CustomSnackbar
        open={snack.open}
        handleClose={handleClose}
        message={snack.message}
        severity={snack.severity}
      />

      <section className='min-h-screen  m-4 space-y-8'>
        <div className='flex flex-col items-center mt-4'>
          <h1 className='text-2xl font-bold text-black-800'>Notifications</h1>
          <h1 className='text-gray-500'>Add and manage notifications</h1>
        </div>

        {/* Form Section */}
        <div className='bg-white rounded-lg shadow-sm p-6 border flex items-center justify-content-evenly'>
          {/* Notification */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            
            <label htmlFor="notification" style={{ fontWeight: 'bold', color: '#333' }}>Add Notification <span className='text-red-500'>*</span></label>
            <TextareaAutosize
              id="notification"
              minRows={1}
              maxRows={1}
              value={notification}
              onChange={(e) => setNotification(e.target.value)}
              placeholder="Add your notification here"
              style={{
                width: 300,
                padding: '8px',
                fontSize: '14px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                resize: 'none',
                overflowX:'scroll'
              }}
            />
          </div>

          {/* Link */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label htmlFor="notification-link" style={{ fontWeight: 'bold', color: '#333' }}>Add Link</label>
            <input
              type="url"
              id="notification-link"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="Enter URL"
              style={{
                padding: '8px',
                fontSize: '14px',
                borderRadius: '4px',
                border: link && !isValidUrl(link) ? '1px solid red' : '1px solid #ccc',
              }}
            />
            {link && !isValidUrl(link) && (
              <span style={{ color: 'red', fontSize: '12px' }}>
                Please enter a valid URL 
              </span>
            )}
          </div>

          {/* File Upload */}
          <div
  onDragOver={(e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = '#e6f7ff';
  }}
  onDragLeave={(e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = '';
  }}
  onDrop={(e) => handleFileDrop(e, setFile, setFileError, triggerSnackbar)}
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '10px',
    border: '2px dashed #ccc',
    borderRadius: '8px',
    cursor: 'pointer',
  }}
>
  <label style={{ fontWeight: 'bold', color: '#333' }}>Upload Document</label>

  <div
    onClick={() => document.getElementById('document').click()}
    className="block w-full px-3 py-2 border rounded text-sm text-gray-900 cursor-pointer truncate"
  >
    {file
      ? typeof file === 'string'
        ? `Uploaded: ${file.split('/').pop().replace(/^\d+/, '')}`
        : `Selected: ${file.name}`
      : 'Drag and drop OR Click to choose a file'}
  </div>

  <input
    type="file"
    id="document"
    accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.png,.jpg,.jpeg,.gif"
    className="hidden"
    onChange={(e) => {
      const selectedFile = e.target.files[0];
      const input = document.getElementById('document');

      if (selectedFile && selectedFile.size > 6 * 1024 * 1024) {
        triggerSnackbar('error', 'File size should be less than 6MB');
        setFileError('File size should be less than 6MB');
        setFile(null);
        if (input) input.value = '';
        return;
      }

      setFile(selectedFile);
      setFileError('');
    }}
  />

  {fileError && (
    <div style={{ color: 'red', fontSize: '12px' }}>{fileError}</div>
  )}
</div>



          {/* Save/Cancel Buttons */}
          <Stack spacing={2} direction="row" style={{ padding: '16px',marginTop: '20px' }}>
            {isEditing && (
              <button
              className='btn btn-outline-secondary'
                onClick={() => {
                  setIsEditing(false);
                  setEditId(null);
                  setNotification('');
                  setLink('');
                  setFile(null);
                  const input = document.getElementById('document');
                  if (input) input.value = '';
                }}
               
              >
                Cancel
              </button>
            )}
           
           <Box>
  <button
   className='btn btn-success'
    onClick={handleSave}
    disabled={isEditing && isUnchanged || notification === ''}
    
  >
    {isEditing ? 'Update' : 'Add'}
  </button>
</Box>

           
          </Stack>
        </div>

        {/* Table Section */}
        <div className='bg-white rounded-lg shadow-sm p-4 border'>
          <div className='border-b pb-3 border-gray-200'>
            <h1 className='text-xl text-danger'>Saved Entities</h1>
            <p>{savedData.length} notifications saved</p>
          </div>

          <table className="min-w-full border-collapse">
            <thead className="sticky top-0 z-10 bg-black w-full text-white">
              <tr>
                <th className="px-4 py-3 text-center text-sm border-none">Sl.No</th>
                <th className="px-4 py-3 text-center text-sm border-none">Created At</th>
                <th className="px-4 py-3 text-center text-sm border-none">Notification</th>
                <th className="px-4 py-3 text-center text-sm border-none">Link</th>
                <th className="px-4 py-3 text-center text-sm border-none">Document</th>
                <th className="px-4 py-3 text-center text-sm border-none">Action</th>
              </tr>
            </thead>
            <tbody>
              {savedData.length > 0 ? (
                savedData.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 border-b">
                    <td className="px-4 py-3 border-none text-center">{index + 1}</td>
                    <td className="px-4 py-3 border-none text-center">
                      {new Date(item.createdAt).toLocaleDateString('en-GB')}
                    </td>

                    <td className="px-4 py-3 border-none text-center">{item.Update}</td>
                    <td className="px-4 py-3 border-none text-center">
                      {item.RefLink ? (
                        <a href={item.RefLink}  target="_blank" rel="noopener noreferrer" title="Open link" className="flex justify-content-center">
                          <FaLink className="text-red-600 hover:text-red-800" />
                        </a>
                      ) : 'N/A'}
                    </td>
                    <td className="px-4 py-3 border-none text-center">
                      {item.FileUrl ? (
                        <div className='d-flex justify-content-center gap-2'>
                        <a href={`https://docs.google.com/gview?url=${item.FileUrl}&embedded=true`} download target="_blank" rel="noopener noreferrer" title="Open document" 
                         className="flex gap-1 items-center px-1 py-1 text-sm">
                         <MdFileOpen className="text-lg text-green-600" />
                                             <span>View</span>
                                             
 </a>
                          <a
                            href={item.FileUrl}
                            target='_blank'
                            rel="noopener noreferrer"
                            download
                            className="flex gap-2 items-center px-1 py-1 text-sm"
                            title='Download document'
                          >
                          <FaFileDownload className="text-base text-blue-600" />
                                              <span>Download</span>
                          </a>
                       </div>
                      
                      ) : 'N/A'}
                    </td>
                    <td className="px-4 py-3 border-none text-center">
                      <div className="flex justify-center gap-3">
                        <button
                          title="Edit"
                          className="px-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                          onClick={() => {
                            setIsEditing(true);
                            setEditId(item.id);
                            setNotification(item.Update);
                            setLink(item.RefLink);
                            setOriginalNotification(item.Update);
                            setOriginalLink(item.RefLink);
                            setFile(item.FileUrl ? item.FileUrl.split('/').pop().split('-').slice(1).join('-') : '');
                            const input = document.getElementById('document');
                            if (input) input.value = '';
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          <MdEditDocument className="text-lg text-blue-600"  />
                        </button>
                        <button
                          title="Delete"
                                                            className="px-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                          onClick={() => handleDelete(item.id)}
                        >
                       <MdDelete className="text-lg text-red-600"  />                          
                        
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-gray-500">No entries found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default NotificationsSection;
